export function LlmPill({ id, label }: { id: string; label: string }) {
  return (
    <span className="llm-pill" title={id}>
      {label}
    </span>
  );
}
